import React from "react";
import PropTypes from "prop-types";
import Input from "antd/lib/input";
import { getDefaultName } from "../../pages/indexer/Indexer";
import map from "lodash/map";
import { Indexer as IndexerType } from "@/components/proptypes";
import FavoritesControl from "@/components/favorites-control/FavoritesControl";
import { IndexerTagsControl } from "@/components/tags-control/TagsControl";
import getTags from "@/services/getTags";
import { useTheme } from "@/components/ThemeProvider";

import "./Title.less";

function getIndexerTags() {
  return getTags("api/indexers/tags").then(tags => map(tags, t => t.name)) || [];
}

export default function Title({ 
  indexer, 
  editMode, 
  name, 
  children, 
  tagsExtra,
  onChange,  
  canEdit,
  setIndexerTags,
}) {
  const defaultName = getDefaultName(indexer);
  const { isDarkMode } = useTheme();

  return (
    <div className={`indexer-header ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className={`title-with-tags ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className={`page-title ${isDarkMode ? 'dark-mode' : ''}`}>
          <div className={`d-flex align-items-center ${isDarkMode ? 'dark-mode' : ''}`}>
            {indexer.id && <FavoritesControl item={indexer} />}
            <h3>
              {editMode && indexer.query ? (
                <Input
                  className="f-inherit"
                  placeholder={defaultName}
                  value={name}
                  aria-label="Indexer title"
                  onChange={e => onChange(e.target.value)}
                />
              ) : (
                name || defaultName
              )}
            </h3>
          </div>
        </div>
        <div className={`indexer-tags ${isDarkMode ? 'dark-mode' : ''}`}>
          <IndexerTagsControl
            tags={indexer.tags}
            isArchived={indexer.is_archived}
            canEdit={canEdit}
            getAvailableTags={getIndexerTags}
            onEdit={setIndexerTags}
            tagsExtra={tagsExtra}
          />
        </div>
      </div>
      <div className={`header-actions ${isDarkMode ? 'dark-mode' : ''}`}>
        {children}
      </div>
    </div>
  );
}

Title.propTypes = {
  indexer: IndexerType.isRequired,
  editMode: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node,
  tagsExtra: PropTypes.node,
  onChange: PropTypes.func,
  canEdit: PropTypes.bool,
  setIndexerTags: PropTypes.func,
};

Title.defaultProps = {
  editMode: false,
  name: null,
  children: null,
  tagsExtra: null,
  onChange: () => {},
  canEdit: false,
  setIndexerTags: () => {},
};
